import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import SearchPage from '../SearchPage'

function Search() {
   return (
     <div>
       <Header />
       <div className="app__page">
         <Sidebar />
         <SearchPage />
       </div>
     </div>
   )

}

export default Search
